<div class="main">
    <h2>Our Program</h2>
   <section class="timeline">
    
    <div class="container">
        <div class="timeline-item">         
            <div class="timeline-content timeline-card " data-aos="fade-right" data-aos-duration="1500">
              <div class="header"> 
                <img src="../../../assets/background/program/day1.png" alt="">
              </div>
              <div class="date">Day 1</div>
            </div>
          </div>  

          <div class="timeline-item">
            <div class="timeline-content timeline-card " data-aos="fade-left" data-aos-duration="1500">
              <div class="header"> 
                <img src="../../../assets/background/program/day2.png" alt="">
              </div>
              <div class="date">Day 2</div>
            </div>
          </div> 
          <div class="timeline-item">
            <div class="timeline-content timeline-card " data-aos="fade-right" data-aos-duration="1500">
              <div class="header"> 
                <img src="../../../assets/background/program/day3.png" alt="">
              </div>
              <div class="date">Day 3</div>
            </div>
          </div>  
        
    </div>
  </section>
  <div class="block">
    <h2>Our Packs</h2>
  <div class="packs">
    <div  class="block"  style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.536), rgb(26, 4, 20)),
url(../../../assets/background/program/pilot.jpg) ;    background-size:cover;" >
   <div class="content" >
      <p class="counter" data-aos-duration="1000" data-aos="fade-right" > Pilot Pack</p>
<p class="def" data-aos-duration="1500" data-aos="fade-right" >This is where you get to use all your knowledge and previous trainings. You'll get to participate in our long-awaited Makeathon in partnership with the giants of the IT industry. If you have a team, sign up with them. If you don't, you can sign up individually and we'll match you with other fellow teammates. You will not only come up with an idea that solves the Makeathon's problem but also collaborate with your teammates to build an adequate prototype.
   </p>
   </div>
</div>

<div  class="block"  style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.536), rgb(26, 4, 20)),
url(../../../assets/background/program/commander.jpg) ;    background-size:cover;" >
   <div class="content" >
      <p class="counter" data-aos-duration="1000" data-aos="fade-right" >Commander Pack</p>
<p class="def" data-aos-duration="1500" data-aos="fade-right" >Ever wondered what it feels like to build a business idea and communicate it in front of a crowd? Well, this pack is for you! You will get to unleash your entrepreneurial spirit and enhance your soft skills. This pack in particular is so important since many young engineers struggle to showcase their work despite having overflowing technical skills. So, if you're one of those who are technically adept but still lack presentational skills, this is for you.
   </p>
   </div>
</div>

<div  class="block"  style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.536), rgb(26, 4, 20)),
url(../../../assets/background/program/voyager.jpg) ;    background-size:cover;" >
   <div class="content" >
      <p class="counter" data-aos-duration="1000" data-aos="fade-right" >Voyager Pack</p>
<p class="def" data-aos-duration="1500" data-aos="fade-right" >If you are willing to enjoy your time but also attend our workshops and gain a new skill in the robotics and automation field, then this pack is made for you. You'll get to escape Earth for the weekend and discover your engineering potential
   </p>
   </div>
</div>
   
  </div>
  </div>
</div>
